import { AllowanceCalculatorBlocks } from '@app/shared/utils/enums/allowance-calculator-blocks.enum';
import { NutritionRecommendation } from '@app/core/models';
import { AllowanceParams, AllowanceStep } from '@app/pages/allowance/allowance';

export interface ProductSelectionIncentive {
  /**
   * Show suggestion to add dry product
   */
  showDry: boolean;
  /**
   * Show suggestion to add wet product
   */
  showWet: boolean;
  /**
   * Show suggestion to add treats product
   */
  showTreats: boolean;
}

export interface AllowanceNavigationRoutes {
  /**
   * Where to go when we click on edit patient in the pet summary panel (pet or weight)
   */
  editPatientRoute: string;
  /**
   * Where to go when we click on edit patient in the pet summary panel (pathologies)
   */
  editDiagnosticRoute: string;
  /**
   * Where to go when we click on edit selection in the ration allowance page
   */
  editSelectionRoute: string;
}

export interface SelectedProductIds {
  dry?: string;
  wet?: string;
  treats?: string;
}

export interface AllowanceState {
  step: AllowanceStep;
  nutritionRecommendation: NutritionRecommendation | null;
  defaultNutritionRecommendation: NutritionRecommendation | null;
  gestationNutritionRecommendation: NutritionRecommendation[] | null;
  loadingRecommendation: boolean;
  blockCurrentlyEditing: { [key in AllowanceCalculatorBlocks]: boolean };
  allWetQuantityPerDay: number | null;
  allTreatsQuantityPerDay: number | null;
  allowanceParams: AllowanceParams | null;
  allowanceNavigationRoutes: AllowanceNavigationRoutes | null;
  productSelectionIncentive: ProductSelectionIncentive | null;
}

export const initialAllowanceState: AllowanceState = {
  step: AllowanceStep.Ration,
  nutritionRecommendation: null,
  defaultNutritionRecommendation: null,
  gestationNutritionRecommendation: null,
  loadingRecommendation: false,
  blockCurrentlyEditing: {
    [AllowanceCalculatorBlocks.ALLOCATION]: false,
    [AllowanceCalculatorBlocks.DRY]: false,
    [AllowanceCalculatorBlocks.WET]: false,
    [AllowanceCalculatorBlocks.TREATS]: false,
  },
  allWetQuantityPerDay: null,
  allTreatsQuantityPerDay: null,
  allowanceParams: null,
  allowanceNavigationRoutes: {
    editPatientRoute: '',
    editDiagnosticRoute: '',
    editSelectionRoute: '',
  },
  productSelectionIncentive: {
    showDry: false,
    showWet: false,
    showTreats: false,
  },
};
